import { render } from "./CIS-Accordion-With-Image-Item.vue?vue&type=template&id=7bff4b66"
import script from "./CIS-Accordion-With-Image-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Accordion-With-Image-Item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__